/**
 * Следит за тем, уходила ли вкладка в фон.
 *
 * Сигнал об отрисовке пинов приходит из requestAnimationFrame, а он в скрытой вкладке
 * не вызывается — при этом performance.now() продолжает идти от начала навигации. Поэтому
 * страница, открытая в фоновой вкладке, отправляла не время загрузки карты, а время до момента,
 * когда на неё посмотрели: в первых же данных такие замеры дали выбросы почти в час.
 *
 * Тот же приём использует web-vitals: замер, захвативший период невидимости, не отправляется
 * вовсе. Заменить его на нулевой нельзя — мы не знаем, сколько из этого времени карта
 * действительно работала.
 */

/** Вкладку ни разу не скрывали: любое сравнение с началом замера даёт ложь */
const NEVER_HIDDEN = Number.NEGATIVE_INFINITY;

let lastHiddenAt = NEVER_HIDDEN;

function isHiddenNow(): boolean {
  return typeof document !== 'undefined' && document.visibilityState === 'hidden';
}

if (typeof document !== 'undefined') {
  /** Вкладку открыли в фоне — считаем скрытой с самого начала навигации */
  if (isHiddenNow()) {
    lastHiddenAt = 0;
  }

  document.addEventListener(
    'visibilitychange',
    () => {
      if (document.visibilityState === 'hidden') {
        lastHiddenAt = performance.now();
      }
    },
    { passive: true },
  );
}

/**
 * Была ли вкладка скрыта в любой момент замера, начавшегося в startedAt.
 * Для сквозных метрик страницы startedAt равен нулю — это начало навигации.
 */
export function wasPageHiddenSince(startedAt: number): boolean {
  return isHiddenNow() || lastHiddenAt >= startedAt;
}

/** Только для тестов: возвращает модуль в состояние ни разу не скрытой вкладки */
export function resetPageVisibility() {
  lastHiddenAt = NEVER_HIDDEN;
}
